import { ValidationErrors, ValidatorFn } from '@angular/forms';
import { AbstractControl } from '@angular/forms';
import * as moment from 'moment';

type NdmsValidationErrors = {
    [key: string]: {
        message: string
    }
}

export class NdmsValidators {
    static email(control: AbstractControl): NdmsValidationErrors | null {
        const emailPattern = /^\d{3}\-\d{2}\-\d{4}$/;

        if (control.value && !emailPattern.test(control.value)) {
            return {
                socialSecurityNumber: {
                    message: 'Invalid Format'
                }
            }
        }

        return null;
    }

    static maxTime(max: Date): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
          return !moment(new Date(control.value)).isValid() || !moment(max, moment.ISO_8601).isValid()
              ? null
              :  moment(max, moment.ISO_8601) > moment(new Date(control.value))
                  ? null
                  : { maxTime: { message: 'Cannot be greater than or equal to ' + moment(max, moment.ISO_8601).format("HH:mm") } };
      };
    }

    static minTime(min: Date): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            return !moment(new Date(control.value)).isValid() || !moment(min, moment.ISO_8601).isValid()
                ? null
                :  moment(min, moment.ISO_8601) < moment(new Date(control.value))
                    ? null
                    : { minTime: { message: 'Cannot be less than or equal to ' + moment(min, moment.ISO_8601).format("HH:mm") } };
        };
    }

    static maxValue(max: number): ValidatorFn {
      return (control: AbstractControl): NdmsValidationErrors | null => {
          if (control.value > max) {
              return {
                  minValue: {
                      message: "Cannot be larger than " + max
                  }
              };
          }
          return null;
      };
    }

    static minValue(min: number): ValidatorFn {
        return (control: AbstractControl): NdmsValidationErrors | null => {
            if (control.value < min) {
                return {
                    minValue: {
                        message: "Cannot be less than " + min
                    }
                };
            }
            return null;
        };
    }

    static noSpace(control: AbstractControl) {
        if (control.value) {
            let s: string = control.value;
            if (s.charAt(s.length - 1) == ' ' || s.trim() == '' || s.trim().indexOf(' ') != -1)

                control.setValue(s.replace(" ", ""));
        }
        return null;
    }

    static overlap(min: Date, max: Date, ): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        return !moment(new Date(control.value)).isValid()
          ? null
          : { overlap: { message: 'Cannot overlap the shift at ' +
              moment(min, moment.ISO_8601).format("HH:mm") + ' to ' +
              (min.getDate() != max.getDate() ? '24:00' :
              moment(max, moment.ISO_8601).format("HH:mm")) } };
      };
    }

    static postalCode(control: AbstractControl): NdmsValidationErrors | null {
        const postalCodePattern = /^\d{5}(-\d{4}|-_{4})?$/;

        if (control.value && !postalCodePattern.test(control.value)) {
            return {
                postalCode: {
                    message: 'Postal code must be in valid format'
                }
            }
        }

        return null;
    }

    static socialSecurityNumber(control: AbstractControl): NdmsValidationErrors | null {
        const socialSecurityNumberPattern = /^\d{3}\-\d{2}\-\d{4}$/;

        if (control.value && !socialSecurityNumberPattern.test(control.value)) {
            return {
                socialSecurityNumber: {
                    message: 'Invalid SSN'
                }
            }
        }

        return null;
    }

    static socialSecurityNumberLastFour(control: AbstractControl): NdmsValidationErrors | null {
        const socialSecurityNumberPattern = /^\d{4}$/;

        if (control.value && !socialSecurityNumberPattern.test(control.value)) {
            return {
                socialSecurityNumber: {
                    message: 'Invalid SSN'
                }
            }
        }

        return null;
    }

}
